"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaultService = exports.handleFaultsInboxDateRangeFilter = exports.handleFaultsInboxIsResolvedFilter = exports.hanbleFaultsTeletableFilter = exports.handleFaultsInboxMoreFilters = exports.handleFaultsInboxFaultTypeFilter = exports.handleResolveFaults = exports.handleFaultsTeletableSetPagination = exports.handleGotInboxData = exports.getFaultEventHistoryDataForVin = exports.putToggleFaultIsResolved = exports.composeFilterFunc = exports.faultEventListHasFilters = exports.handleNeedsMoreFaultsInboxDataAction = exports.handleNeedsFaultsInboxDataAction = exports.getFaultsInboxData = exports.handleNeedsFaultsInboxCsvDataAction = exports.getFaultsInboxCsvData = exports.buildPagingQueryString = exports.handleRequestRingBufferDataAction = exports.getFaultRingBufferData = exports.handleRequestFaultDetailsByStreamingSourceAndIdAction = exports.handleRequestFaultDetailsByRowKeyAction = exports.handleRequestFaultDetailsByStreamingSourceAndEventIdAction = exports.handleRequestFaultDetailsAction = exports.getFaultDetailsByStreamingSourceAndId = exports.getFaultDetailsByStreamingSourceAndEventId = exports.getFaultDetailsByRowKey = exports.getFaultDetails = exports.handleRemoveFlagAction = exports.deleteFaultFlag = exports.handleAddFlagAction = exports.putAndConvertFaultFlag = exports.putFaultFlag = exports.convertFlagResponseToStateModel = exports.convertFlagModelToStateModel = void 0;
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable prefer-destructuring */
var fileSaver = __importStar(require("file-saver"));
var moment_1 = __importDefault(require("moment"));
var dvs_core_dcp_client_constants_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants"));
var conversions_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/conversions");
var faults_1 = require("../utils/faults");
var paging_model_1 = require("../models/paging.model");
var ringBuffer_1 = require("../utils/ringBuffer");
var ProxyApi_1 = __importDefault(require("../services/ProxyApi"));
var table_slice_1 = require("../slices/table.slice");
var faults_2 = require("../constants/faults");
var faults_model_1 = require("../models/faults.model");
var faults_slice_1 = require("../slices/faults.slice");
var faults_selector_1 = require("../selectors/faults.selector");
var common_1 = require("../utils/common");
var app_1 = __importDefault(require("../constants/app"));
var user_model_1 = require("../models/user.model");
var user_selector_1 = require("../selectors/user.selector");
var proxyApi_1 = require("../constants/proxyApi");
var CSV = dvs_core_dcp_client_constants_1.default.SHARED_LOCALE_STRINGS.FAULTS.CSV;
var convertFlagModelToStateModel = function (flagModel) { return ({
    faultId: flagModel.FaultId,
}); };
exports.convertFlagModelToStateModel = convertFlagModelToStateModel;
var convertFlagResponseToStateModel = function (vehicleFaultEvents) {
    var convertedFlags = {};
    vehicleFaultEvents.filter(function (faultEvent) { return faultEvent.flagged === true; })
        .forEach(function (faultEvent) {
        convertedFlags[faultEvent.vtEventId] = {
            faultId: faultEvent.vtEventId,
        };
    });
    return convertedFlags;
};
exports.convertFlagResponseToStateModel = convertFlagResponseToStateModel;
var putFaultFlag = function (tan, faultId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.PATCH.FAULT.TAN_UPDATE_FLAG_RESOLVE.replace(/:tan/, tan));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'PATCH',
                        data: { flag: true, faults: [faultId] },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
exports.putFaultFlag = putFaultFlag;
var putAndConvertFaultFlag = function (tan, faultId) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
    switch (_b.label) {
        case 0:
            _a = exports.convertFlagModelToStateModel;
            return [4 /*yield*/, (0, exports.putFaultFlag)(tan, faultId)];
        case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
    }
}); }); };
exports.putAndConvertFaultFlag = putAndConvertFaultFlag;
var handleAddFlagAction = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var tan, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                tan = (0, common_1.getTan)();
                return [4 /*yield*/, (0, exports.putFaultFlag)(tan, action.payload.faultId)];
            case 1:
                _a.sent();
                api.dispatch({
                    type: faults_slice_1.FAULTS_FLAG_ADDED_ACTION,
                    payload: {
                        faultId: action.payload.faultId,
                        flag: {
                            faultId: action.payload.faultId,
                            rowKey: action.payload.rowKey,
                        },
                    },
                });
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                api.dispatch({ type: faults_slice_1.FAULTS_ADD_FLAG_ERROR_ACTION, payload: { error: error_1, faultId: action.payload.faultId } });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.handleAddFlagAction = handleAddFlagAction;
var deleteFaultFlag = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var tan, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.PATCH.FAULT.TAN_UPDATE_FLAG_RESOLVE.replace(':tan', tan));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'PATCH',
                        data: body,
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteFaultFlag = deleteFaultFlag;
var handleRemoveFlagAction = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var faultFlag, bodyRequest, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                faultFlag = api.getState().faults.flags[action.payload.faultId];
                bodyRequest = { flag: false, faults: [faultFlag.faultId] };
                return [4 /*yield*/, (0, exports.deleteFaultFlag)(bodyRequest)];
            case 1:
                _a.sent();
                api.dispatch({ type: faults_slice_1.FAULTS_FLAG_REMOVED_ACTION, payload: { faultId: action.payload.faultId } });
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                api.dispatch({ type: faults_slice_1.FAULTS_REMOVE_FLAG_ERROR_ACTION, payload: { error: error_2, faultId: action.payload.faultId } });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.handleRemoveFlagAction = handleRemoveFlagAction;
/**
 * Preffer to use getFaultDetailsByStreamingSourceAndEventId instead.
 * This is only used by Virtual Technician to verify if the fault event exists.
 */
var getFaultDetails = function (eventId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.VT_EVENT_BY_ID.replace(':eventId', eventId));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'GET',
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
exports.getFaultDetails = getFaultDetails;
/**
 * @deprecated Use getFaultDetailsByStreamingSourceAndId instead
 */
var getFaultDetailsByRowKey = function (rowKey) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.EVENT_BY_ROWKEY.replace(':rowKey', rowKey));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'GET',
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
exports.getFaultDetailsByRowKey = getFaultDetailsByRowKey;
/**
 * Loads fault event details by event id and streaming source
 * @param streamingSource - either gvh or legacy
 * @param eventId - event id
 * @returns Fault event details
 */
var getFaultDetailsByStreamingSourceAndEventId = function (_a) {
    var eventId = _a.eventId, streamingSource = _a.streamingSource;
    return __awaiter(void 0, void 0, void 0, function () {
        var url, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.EVENT_BY_STREAMING_SOURCE_AND_EVENT_ID.replace(':streamingSource', streamingSource).replace(':eventId', eventId));
                    return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                            url: url,
                            method: 'GET',
                        })];
                case 1:
                    data = (_b.sent()).data;
                    // Ensures rowKey has a value by setting rowKey to faultId when streamingSoure is GVH and rowKey is not present
                    data.rowKey = data.rowKey || data.faultId;
                    return [2 /*return*/, data];
            }
        });
    });
};
exports.getFaultDetailsByStreamingSourceAndEventId = getFaultDetailsByStreamingSourceAndEventId;
/**
 * Loads fault details by fault id or row key depending on the streaming source
 * @param streamingSource - either gvh or legacy
 * @param id - fault id when streaming source is gvh or row key when streaming source is legacy
 * @returns Fault details
 */
var getFaultDetailsByStreamingSourceAndId = function (_a) {
    var id = _a.id, streamingSource = _a.streamingSource;
    return __awaiter(void 0, void 0, void 0, function () {
        var url, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.EVENT_BY_STREAMING_SOURCE_AND_ID.replace(':streamingSource', streamingSource).replace(':rowKeyOrFaultId', id));
                    return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                            url: url,
                            method: 'GET',
                        })];
                case 1:
                    data = (_b.sent()).data;
                    // Ensures rowKey has a value by setting rowKey to faultId when streamingSoure is GVH and rowKey is not present
                    data.rowKey = data.rowKey || data.faultId;
                    return [2 /*return*/, data];
            }
        });
    });
};
exports.getFaultDetailsByStreamingSourceAndId = getFaultDetailsByStreamingSourceAndId;
var handleRequestFaultDetails = function (fetcher) { return function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var response, unitsSystemType, convertedData, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetcher(action.payload)];
            case 1:
                response = _a.sent();
                unitsSystemType = user_selector_1.UserAccessors.getUserUnitsSystemType(api.getState());
                convertedData = unitsSystemType === user_model_1.UNITS_SYSTEM_TYPES.METRIC ? (0, faults_1.convertFaultDetailsToMetric)(response) : (0, faults_1.convertFaultDetailsToImperial)(response);
                (0, faults_slice_1.dispatchReceiveFaultDetailsAction)(__assign(__assign({}, convertedData), { vtEventId: response.rowKey }))(api.dispatch);
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                api.dispatch({ type: faults_slice_1.FAULT_DETAILS_ERROR });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; }; };
/**
 * @deprecated Use handleRequestFaultDetailsByStreamingSourceAndEventIdAction instead
 */
exports.handleRequestFaultDetailsAction = handleRequestFaultDetails(exports.getFaultDetails);
/**
 * Loads fault event details by event id and streaming source and converts the data to the correct units system
 * @param streamingSource - either gvh or legacy
 * @param eventId - event id
 * @returns Fault event details converted to the correct units system
 */
exports.handleRequestFaultDetailsByStreamingSourceAndEventIdAction = handleRequestFaultDetails(exports.getFaultDetailsByStreamingSourceAndEventId);
/**
 * @deprecated Use handleRequestFaultDetailsByStreamingSourceAndIdAction instead
 */
exports.handleRequestFaultDetailsByRowKeyAction = handleRequestFaultDetails(exports.getFaultDetailsByRowKey);
/**
 * Loads fault details by fault id or row key depending on the streaming source and converts the data to the correct units system
 * @param streamingSource - either gvh or legacy
 * @param id - fault id when streaming source is gvh or row key when streaming source is legacy
 * @returns Fault details converted to the correct units system
 */
exports.handleRequestFaultDetailsByStreamingSourceAndIdAction = handleRequestFaultDetails(exports.getFaultDetailsByStreamingSourceAndId);
var getFaultRingBufferData = function (eventId) { return __awaiter(void 0, void 0, void 0, function () {
    var tan, url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.TAN_EVENT_BY_RINGBUFFER_ROWKEY.replace(':tan', tan).replace(':rowKey', eventId));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'GET',
                    })];
            case 1:
                data = (_a.sent()).data;
                // TODO: The API returns an error with a 'key' attribute if the fault does not have ring buffer data. We should return an error from API so we don't have to do this.
                if (!Object.keys(data).includes('key')) {
                    return [2 /*return*/, data];
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
exports.getFaultRingBufferData = getFaultRingBufferData;
var handleRequestRingBufferDataAction = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var faultId, unitsSystemType, response, convertedData, error_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                faultId = action.payload;
                unitsSystemType = user_selector_1.UserAccessors.getUserUnitsSystemType(api.getState());
                return [4 /*yield*/, (0, exports.getFaultRingBufferData)(faultId)];
            case 1:
                response = _b.sent();
                convertedData = unitsSystemType === user_model_1.UNITS_SYSTEM_TYPES.METRIC ? (0, ringBuffer_1.convertRingBufferDataToMetric)(response) : response;
                api.dispatch({ type: faults_slice_1.FAULTS_RECIEVE_FAULT_RING_BUFFER_DATA, payload: (_a = {}, _a[faultId] = convertedData, _a) });
                return [3 /*break*/, 3];
            case 2:
                error_4 = _b.sent();
                api.dispatch({ type: faults_slice_1.FAULTS_RING_BUFFER_DATA_ERROR });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.handleRequestRingBufferDataAction = handleRequestRingBufferDataAction;
var feiCsvStringFromFaultsAndFlags = function (faults) {
    var columnHeaders = [
        CSV.FAULT_SEVERITY,
        CSV.FAULT_CODE,
        CSV.TITLE,
        CSV.SERIAL,
        CSV.UNIT_ID,
        CSV.TIME,
        CSV.GEOFENCE,
        CSV.RING_BUFFER,
        CSV.SOURCE_ADDRESS,
    ];
    var faultsCsv = faults.map(function (fault) { return [
        fault.fc,
        "\"".concat(fault.sa, "/").concat(fault.spn, "/").concat(fault.fmi, "\""),
        "\"".concat(fault.spnText, "/").concat(fault.fmiText, "\""),
        // eslint-disable-next-line no-nested-ternary
        fault.serial ? "\"".concat(fault.serial, "\"") : fault.vin ? "\"".concat((0, conversions_1.deriveSerialFromVin)(fault.vin), "\"") : '',
        fault.unitId || '',
        // This time format doesn't seem to be consistent with any other time formats across the Portal
        // so it's just done as a one-off instead of incorporating it into Timestamp (timestamp.ts).
        moment_1.default.utc(fault.timestamp.toString(), 'x', true).format('YYYY-MM-DD HH:mm:ss'),
        (!!fault.atDealer).toString(),
        !!fault.faultType && fault.faultType === '3' ? 'true' : 'false',
        fault.sa.toString(),
    ]; });
    faultsCsv.unshift(columnHeaders);
    return faultsCsv.map(function (arr) { return arr.join(','); }).join('\n');
};
var buildPagingQueryString = function (pagingData, rowKey) {
    var query = '&';
    var appendCriteria = function (criteria) {
        query += "".concat(criteria, "&");
    };
    if (rowKey) {
        appendCriteria("offsetRowKey=".concat(rowKey));
    }
    if (pagingData.startDate) {
        var startDateMidNightTime = pagingData.startDate;
        startDateMidNightTime.set('hour', 0);
        startDateMidNightTime.set('second', 0);
        startDateMidNightTime.set('minute', 0);
        appendCriteria("startTimeStamp=".concat(startDateMidNightTime.valueOf()));
    }
    if (pagingData.endDate) {
        appendCriteria("endTimeStamp=".concat(pagingData.endDate.valueOf()));
    }
    if (!!pagingData.recordsToFetch && pagingData.recordsToFetch !== 0) {
        appendCriteria("recordCount=".concat(pagingData.recordsToFetch));
    }
    if (pagingData.filters) {
        var keys_1 = pagingData.filters;
        // Map of filter name from pagingData to query parameter name for simple pass-through filters
        var basicFilters = [
            'sourceAddress',
            'suspectParameterNumber',
            'failureModeIndicator',
            'serial',
            'title',
            'unitId',
            'sources',
        ];
        var detroitComponent_1 = 'detroit';
        var detroitComponentQueryString_1 = 'CTP,VTHU';
        // Use map to check all the basic filters and add them to the query string
        basicFilters.forEach(function (f) {
            if (!!keys_1[f] && !keys_1[f].includes('')) {
                if (detroitComponent_1.startsWith(keys_1[f].toString().toLowerCase())) {
                    appendCriteria("".concat(f, "=").concat(detroitComponentQueryString_1));
                    return;
                }
                appendCriteria("".concat(f, "=").concat(keys_1[f][0]));
            }
        });
        if (!!keys_1[paging_model_1.PagingMetadataFilterKey.IS_RESOLVED] && keys_1[paging_model_1.PagingMetadataFilterKey.IS_RESOLVED].includes('true')) {
            appendCriteria('resolved=true');
        }
        else {
            appendCriteria('resolved=false');
        }
        if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY]) {
            // Map of filter name from pagingData.Fc to query parameter name
            var faultTypesKey = 'faultTypes';
            var faultCodeFilters_1 = {
                SI: 'SI',
                SN: 'SN',
                SS: 'SS',
                SP: 'SP',
            };
            var selectedFaultCodes_1 = [];
            // Use map to check all the fault code filters and add them to the query string
            Object.keys(faultCodeFilters_1).forEach(function (f) {
                if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY].includes(f)) {
                    selectedFaultCodes_1.push(faultCodeFilters_1[f]);
                }
            });
            if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY].length > 0) {
                appendCriteria("".concat(faultTypesKey, "=").concat(selectedFaultCodes_1.join(',')));
            }
        }
        var isBoxChecked_1 = keys_1[paging_model_1.PagingMetadataFilterKey.MORE_FILTERS];
        if (isBoxChecked_1) {
            var options = [
                {
                    key: 'flagged',
                    on: 'IS_FLAGGED',
                    off: 'IS_NOT_FLAGGED',
                },
                {
                    key: 'ringBuffer',
                    on: 'HAS_RING_BUFFER',
                    off: 'HAS_NO_RING_BUFFER',
                },
                {
                    key: 'geofence',
                    on: 'INSIDE_GEOFENCE',
                    off: 'OUTSIDE_GEOFENCE',
                },
                {
                    key: 'emailSent',
                    on: 'EMAIL_SENT',
                    off: 'EMAIL_NOT_SENT',
                },
            ];
            options.forEach(function (option) {
                var isOn = isBoxChecked_1.includes(faults_model_1.MoreFaultFiltersKey[option.on]);
                var isOff = isBoxChecked_1.includes(faults_model_1.MoreFaultFiltersKey[option.off]);
                if ((isOn) && (isOff)) {
                    // this will return all if both boxes are checked
                }
                else if (isOn) {
                    appendCriteria("".concat(option.key, "=true"));
                }
                else if (isOff) {
                    appendCriteria("".concat(option.key, "=false"));
                }
            });
        }
    }
    // Remove last '&' or '?' character
    return query.slice(0, -1);
};
exports.buildPagingQueryString = buildPagingQueryString;
var getFaultsInboxCsvData = function (pagingData) { return __awaiter(void 0, void 0, void 0, function () {
    var allRecords, query, tan, url, data, pagedResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allRecords = __assign(__assign({}, pagingData), { recordsToFetch: 0 });
                query = (0, exports.buildPagingQueryString)(allRecords);
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.FAULT_SEARCH.replace(':tan', tan)).concat(query);
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'GET',
                    })];
            case 1:
                data = (_a.sent()).data;
                pagedResponse = {
                    Data: data,
                    Paging: pagingData,
                };
                // Ensures rowKey has a value by setting rowKey to faultId when streamingSoure is GVH and rowKey is not present
                pagedResponse.Data.map(function (fault) { return ({
                    rowKey: fault.rowKey || fault.faultId,
                }); });
                return [2 /*return*/, pagedResponse];
        }
    });
}); };
exports.getFaultsInboxCsvData = getFaultsInboxCsvData;
var handleNeedsFaultsInboxCsvDataAction = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var currentPaging, response, csvData, csv, tan, isResolved, dateFormat, dateFrom, dateTo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentPaging = api.getState().faults.faultInboxPaging;
                return [4 /*yield*/, (0, exports.getFaultsInboxCsvData)(currentPaging)];
            case 1:
                response = _a.sent();
                if (!response) {
                    return [2 /*return*/];
                }
                csvData = feiCsvStringFromFaultsAndFlags(response.Data);
                csv = new Blob([csvData], { type: 'text/plain;charset=utf-8' });
                tan = api.getState().user.Customer.Tan;
                isResolved = action.payload.isResolved ? 'Resolved' : 'Unresolved';
                dateFormat = 'YYYYMMDD';
                dateFrom = currentPaging.startDate ? currentPaging.startDate.format(dateFormat) : 'Unknown';
                dateTo = currentPaging.endDate ? currentPaging.endDate.format(dateFormat) : 'Unknown';
                fileSaver.saveAs(csv, "".concat(tan, "_").concat(isResolved, "_").concat(dateFrom, "_").concat(dateTo, ".csv"));
                (0, faults_slice_1.dispatchGotFaultsInboxCsv)()(api.dispatch);
                return [2 /*return*/];
        }
    });
}); }; };
exports.handleNeedsFaultsInboxCsvDataAction = handleNeedsFaultsInboxCsvDataAction;
var currentFaultsRequest = null;
var getFaultsInboxData = function (pagingData, rowKey, vin) { return __awaiter(void 0, void 0, void 0, function () {
    var query, tan, url, data, faultViewData, pagedResponse, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // Cancel any existing request
                if (currentFaultsRequest) {
                    currentFaultsRequest.abort('Canceling previous request');
                }
                // Create new AbortController for this request
                currentFaultsRequest = new AbortController();
                query = (0, exports.buildPagingQueryString)(pagingData, rowKey);
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.GET.FAULT.FAULT_SEARCH.replace(':tan', tan)).concat(query).concat(vin ? "&vin=".concat(vin) : '');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'GET',
                        signal: currentFaultsRequest.signal,
                    })];
            case 2:
                data = (_a.sent()).data;
                // If request was aborted after we got the response but before processing,
                // don't process the data
                if (currentFaultsRequest.signal.aborted) {
                    return [2 /*return*/, {
                            Data: [],
                            Paging: pagingData,
                        }];
                }
                faultViewData = (0, faults_model_1.convertVehicleFaultsToVehicleFaultEvents)(data);
                pagedResponse = {
                    Data: faultViewData,
                    Paging: __assign(__assign({}, pagingData), { currentPage: 1, totalCount: faultViewData.length }),
                };
                pagedResponse.Data = pagedResponse.Data.map(function (fault) { return (__assign(__assign({}, fault), { rowKey: fault.rowKey || fault.faultId })); });
                return [2 /*return*/, pagedResponse];
            case 3:
                error_5 = _a.sent();
                if (error_5.name === 'AbortError' || error_5.name === 'CanceledError') {
                    return [2 /*return*/, {
                            Data: [],
                            Paging: pagingData,
                        }];
                }
                throw error_5;
            case 4:
                if (currentFaultsRequest === null || currentFaultsRequest === void 0 ? void 0 : currentFaultsRequest.signal.aborted) {
                    currentFaultsRequest = null;
                }
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.getFaultsInboxData = getFaultsInboxData;
var currentRequestId = 0;
var handleNeedsFaultsInboxDataAction = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var requestId, response, flagsResponse, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentRequestId += 1;
                requestId = currentRequestId;
                (0, faults_slice_1.faultsSetFaultsInboxIsLoadingAction)(true)(api.dispatch);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, (0, exports.getFaultsInboxData)(action.payload.pagingData)];
            case 2:
                response = _a.sent();
                if (requestId !== currentRequestId) {
                    return [2 /*return*/];
                }
                flagsResponse = (0, exports.convertFlagResponseToStateModel)(response.Data);
                (0, faults_slice_1.dispatchFaultsGotFlagsAction)(flagsResponse)(api.dispatch);
                (0, faults_slice_1.dispatchFaultGotInboxData)(response)(api.dispatch);
                (0, table_slice_1.setSelectedRowsAction)(app_1.default.TABLE.FAULTS.TABLE_ID, [])(api.dispatch);
                return [3 /*break*/, 5];
            case 3:
                error_6 = _a.sent();
                if (requestId !== currentRequestId) {
                    return [2 /*return*/];
                }
                (0, faults_slice_1.dispatchFaultGotInboxDataError)(String(error_6))(api.dispatch);
                return [3 /*break*/, 5];
            case 4:
                if (requestId === currentRequestId) {
                    (0, faults_slice_1.faultsSetFaultsInboxIsLoadingAction)(false)(api.dispatch);
                }
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
exports.handleNeedsFaultsInboxDataAction = handleNeedsFaultsInboxDataAction;
var handleNeedsMoreFaultsInboxDataAction = function (api) {
    return function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var faults, isLoading, rowKey, response, newFaults_1, haveTheNewFaultsAlready, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    faults = api.getState().faults.faultInbox;
                    isLoading = api.getState().faults.faultInboxLoading;
                    // Don't make a new request if we're already loading
                    if (isLoading) {
                        return [2 /*return*/];
                    }
                    // If we don't have any faults, something has gone wrong...
                    if (faults.length === 0) {
                        return [2 /*return*/];
                    }
                    rowKey = faults[faults.length - 1].rowKey;
                    (0, faults_slice_1.faultsSetFaultsInboxIsLoadingAction)(true)(api.dispatch);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, exports.getFaultsInboxData)(action.payload.pagingData, rowKey)];
                case 2:
                    response = _a.sent();
                    newFaults_1 = response.Data;
                    haveTheNewFaultsAlready = faults.some(function (f) { return f.rowKey === newFaults_1[0].rowKey; });
                    if (newFaults_1.length > 0 && !haveTheNewFaultsAlready) {
                        (0, faults_slice_1.dispatchFaultGotMoreInboxData)(response)(api.dispatch);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_7 = _a.sent();
                    (0, faults_slice_1.dispatchFaultGotInboxDataError)(String(error_7))(api.dispatch);
                    return [3 /*break*/, 5];
                case 4:
                    (0, faults_slice_1.faultsSetFaultsInboxIsLoadingAction)(false)(api.dispatch);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.handleNeedsMoreFaultsInboxDataAction = handleNeedsMoreFaultsInboxDataAction;
/** determine if a FaultFilters object computes to true. */
var faultEventListHasFilters = function (filters) { return Object.keys(filters).some(function (key) { return key in filters && filters[key]; }); };
exports.faultEventListHasFilters = faultEventListHasFilters;
/** compose a filter function from VehiclesFilters object. */
var composeFilterFunc = function (filters) { return function (faultEvent) { return faultEvent.filter(function (fault) {
    switch (fault.faultClassification) {
        case faults_model_1.FAULT_CLASSIFICATION.SERVICE_INFO: return filters.serviceInfo;
        case faults_model_1.FAULT_CLASSIFICATION.SERVICE_NOW: return filters.serviceNow;
        case faults_model_1.FAULT_CLASSIFICATION.SERVICE_SOON: return filters.serviceSoon;
        case faults_model_1.FAULT_CLASSIFICATION.SERVICE_PM: return filters.servicePM;
        default: return false;
    }
}); }; };
exports.composeFilterFunc = composeFilterFunc;
var putToggleFaultIsResolved = function (api) { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var tan, url, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.PATCH.FAULT.TAN_UPDATE_FLAG_RESOLVE.replace(/:tan/, tan));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'PATCH',
                        data: {
                            resolve: event.isResolved,
                            faults: [event.vtEventId],
                        },
                    })];
            case 1:
                _a.sent();
                (0, faults_slice_1.dispatchToggleFaultIsResolvedSuccess)(event)(api.dispatch);
                return [3 /*break*/, 3];
            case 2:
                error_8 = _a.sent();
                (0, faults_slice_1.dispatchToggleFaultIsResolvedError)(error_8)(api.dispatch);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.putToggleFaultIsResolved = putToggleFaultIsResolved;
var getFaultEventHistoryDataForVin = function (vin, pagingData) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, (0, exports.getFaultsInboxData)(pagingData, undefined, vin)];
        case 1: return [2 /*return*/, (_a.sent()).Data];
    }
}); }); };
exports.getFaultEventHistoryDataForVin = getFaultEventHistoryDataForVin;
var handleGotInboxData = function () { return function () { return function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/];
}); }); }; }; };
exports.handleGotInboxData = handleGotInboxData;
var handleFaultsTeletableSetPagination = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var currentPaging, newPaging;
    return __generator(this, function (_a) {
        currentPaging = api.getState().faults.faultInboxPaging;
        if (currentPaging.currentPage !== action.payload.pagination.currentPage) {
            newPaging = __assign(__assign({}, currentPaging), { PageNumber: action.payload.pagination.currentPage });
            (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        }
        return [2 /*return*/];
    });
}); }; };
exports.handleFaultsTeletableSetPagination = handleFaultsTeletableSetPagination;
var handleResolveFaults = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var state, faultsToResolve, tan, url, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = api.getState();
                faultsToResolve = faults_selector_1.FaultsSelectors.selectFaultsToResolveObjects(app_1.default.TABLE.FAULTS.TABLE_ID)(state);
                if (faultsToResolve.length === 0)
                    return [2 /*return*/];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                tan = (0, common_1.getTan)();
                url = "".concat(proxyApi_1.BASE_URL).concat(proxyApi_1.PROXY_API.PATCH.FAULT.TAN_UPDATE_FLAG_RESOLVE.replace(/:tan/, tan));
                return [4 /*yield*/, ProxyApi_1.default.protectedRequest({
                        url: url,
                        method: 'PATCH',
                        data: {
                            resolve: action.payload.resolving,
                            faults: faultsToResolve.map(function (f) { return f.vtEventId; }),
                        },
                    })];
            case 2:
                _a.sent();
                (0, faults_slice_1.dispatchFaultNeedsInboxData)(api.getState().faults.faultInboxPaging)(api.dispatch);
                return [3 /*break*/, 4];
            case 3:
                error_9 = _a.sent();
                (0, faults_slice_1.dispatchToggleFaultIsResolvedError)(error_9)(api.dispatch);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.handleResolveFaults = handleResolveFaults;
var handleFaultsInboxFaultTypeFilter = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var faultFilters, currentPaging, values, newPaging;
    var _a;
    return __generator(this, function (_b) {
        faultFilters = action.payload.severityFilters;
        currentPaging = api.getState().faults.faultInboxPaging;
        values = [
            faultFilters.serviceInfo ? faults_2.FAULT_CODES.SI : '',
            faultFilters.serviceNow ? faults_2.FAULT_CODES.SN : '',
            faultFilters.serviceSoon ? faults_2.FAULT_CODES.SS : '',
            faultFilters.serviceInfo ? faults_2.FAULT_CODES.SU : '',
            faultFilters.servicePM ? faults_2.FAULT_CODES.SP : '',
        ].filter(function (a) { return a; });
        newPaging = __assign(__assign({}, currentPaging), { filters: __assign(__assign({}, currentPaging.filters), (_a = {}, _a[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY] = values, _a)) });
        (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        return [2 /*return*/];
    });
}); }; };
exports.handleFaultsInboxFaultTypeFilter = handleFaultsInboxFaultTypeFilter;
var handleFaultsInboxMoreFilters = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var moreFilters, currentPaging, filterNames, newPaging;
    var _a;
    return __generator(this, function (_b) {
        moreFilters = action.payload.moreFilters;
        currentPaging = api.getState().faults.faultInboxPaging;
        filterNames = [
            moreFilters.isFlagged ? faults_model_1.MoreFaultFiltersKey.IS_FLAGGED : '',
            moreFilters.isNotFlagged ? faults_model_1.MoreFaultFiltersKey.IS_NOT_FLAGGED : '',
            moreFilters.hasRingBuffer ? faults_model_1.MoreFaultFiltersKey.HAS_RING_BUFFER : '',
            moreFilters.hasNoRingBuffer ? faults_model_1.MoreFaultFiltersKey.HAS_NO_RING_BUFFER : '',
            moreFilters.insideGeofence ? faults_model_1.MoreFaultFiltersKey.INSIDE_GEOFENCE : '',
            moreFilters.outsideGeofence ? faults_model_1.MoreFaultFiltersKey.OUTSIDE_GEOFENCE : '',
            moreFilters.emailSent ? faults_model_1.MoreFaultFiltersKey.EMAIL_SENT : '',
            moreFilters.emailNotSent ? faults_model_1.MoreFaultFiltersKey.EMAIL_NOT_SENT : '',
        ].filter(function (name) { return !!name; });
        newPaging = __assign(__assign({}, currentPaging), { filters: __assign(__assign({}, currentPaging.filters), (_a = {}, _a[paging_model_1.PagingMetadataFilterKey.MORE_FILTERS] = filterNames, _a)) });
        (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        return [2 /*return*/];
    });
}); }; };
exports.handleFaultsInboxMoreFilters = handleFaultsInboxMoreFilters;
var hanbleFaultsTeletableFilter = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var tableColumnsToApiParams, currentPaging, newPaging;
    var _a;
    return __generator(this, function (_b) {
        tableColumnsToApiParams = {
            'faults-flag': 'flag',
            'faults-faultClassification': 'fc',
            'faults-sa': 'sa',
            'faults-spn': 'spn',
            'faults-fmi': 'fmi',
            'faults-faultTitle': 'title',
            'faults-serial': 'serial',
            'faults-unitId': 'unitId',
            'faults-time': 'timestamp',
            'faults-geofence': 'geofence',
            'faults-ringBuffer': 'ringBuffer',
        };
        currentPaging = api.getState().faults.faultInboxPaging;
        newPaging = __assign(__assign({}, currentPaging), { filters: __assign(__assign({}, currentPaging.filters), (_a = {}, _a[tableColumnsToApiParams[action.payload.columnId]] = action.payload.filterText ? [action.payload.filterText] : [], _a)) });
        (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        return [2 /*return*/];
    });
}); }; };
exports.hanbleFaultsTeletableFilter = hanbleFaultsTeletableFilter;
var handleFaultsInboxIsResolvedFilter = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var currentPaging, newPaging;
    var _a;
    return __generator(this, function (_b) {
        currentPaging = api.getState().faults.faultInboxPaging;
        newPaging = __assign(__assign({}, currentPaging), { filters: __assign(__assign({}, currentPaging.filters), (_a = {}, _a[paging_model_1.PagingMetadataFilterKey.IS_RESOLVED] = ["".concat(action.payload.isResolvedView)], _a)) });
        (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        return [2 /*return*/];
    });
}); }; };
exports.handleFaultsInboxIsResolvedFilter = handleFaultsInboxIsResolvedFilter;
var handleFaultsInboxDateRangeFilter = function (api) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
    var dateRangeFilter, currentPaging, newPaging;
    return __generator(this, function (_a) {
        dateRangeFilter = action.payload.dateRange;
        currentPaging = api.getState().faults.faultInboxPaging;
        newPaging = __assign(__assign({}, currentPaging), { startDate: dateRangeFilter.startDate, endDate: dateRangeFilter.endDate });
        (0, faults_slice_1.dispatchFaultNeedsInboxData)(newPaging)(api.dispatch);
        return [2 /*return*/];
    });
}); }; };
exports.handleFaultsInboxDateRangeFilter = handleFaultsInboxDateRangeFilter;
exports.FaultService = {
    handleAddFlagAction: exports.handleAddFlagAction,
    handleFaultsTeletableSetPagination: exports.handleFaultsTeletableSetPagination,
    hanbleFaultsTeletableFilter: exports.hanbleFaultsTeletableFilter,
    handleGotInboxData: exports.handleGotInboxData,
    handleNeedsFaultsInboxDataAction: exports.handleNeedsFaultsInboxDataAction,
    handleNeedsMoreFaultsInboxDataAction: exports.handleNeedsMoreFaultsInboxDataAction,
    handleRemoveFlagAction: exports.handleRemoveFlagAction,
    handleRequestFaultDetailsAction: exports.handleRequestFaultDetailsAction,
    handleRequestFaultDetailsByRowKeyAction: exports.handleRequestFaultDetailsByRowKeyAction,
    handleRequestFaultDetailsByStreamingSourceAndIdAction: exports.handleRequestFaultDetailsByStreamingSourceAndIdAction,
    handleRequestFaultDetailsByStreamingSourceAndEventIdAction: exports.handleRequestFaultDetailsByStreamingSourceAndEventIdAction,
    handleRequestRingBufferDataAction: exports.handleRequestRingBufferDataAction,
    putToggleFaultIsResolved: exports.putToggleFaultIsResolved,
    handleFaultsInboxFaultTypeFilter: exports.handleFaultsInboxFaultTypeFilter,
    handleFaultsInboxMoreFilters: exports.handleFaultsInboxMoreFilters,
    handleFaultsInboxDateRangeFilter: exports.handleFaultsInboxDateRangeFilter,
    handleNeedsFaultsInboxCsvDataAction: exports.handleNeedsFaultsInboxCsvDataAction,
    handleFaultsInboxIsResolvedFilter: exports.handleFaultsInboxIsResolvedFilter,
    handleResolveFaults: exports.handleResolveFaults,
};
exports.default = exports.FaultService;
